import { gql } from '@apollo/client';

export const QUERY_FAVORITES = gql`
  query favoritesPageableByUserId($userId: ID!, $type: String!, $size: Int!) {
    favorites(
      pagination: { pageSize: $size }
      sort: "createdAt:desc"
      filters: { user: { id: { eq: $userId } }, type: { eq: $type } }
    ) {
      data {
        attributes {
          relationId
          type
          metadata
        }
      }
      meta {
        pagination {
          total
        }
      }
    }
  }
`;

export const QUERY_EXIST_FAVORITE = gql`
  query existByRelationId($relationId: Long!, $userId: ID!) {
    favorites(filters: { relationId: { eq: $relationId }, user: { id: { eq: $userId } } }) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const QUERY_FIND_FAVORITE = gql`
  query findByRelationId($relationId: Long!, $userId: ID!) {
    favorites(filters: { relationId: { eq: $relationId }, user: { id: { eq: $userId } } }) {
      data {
        id
      }
    }
  }
`;

export const QUERY_FAVORITE_PAGE = gql`
  query favouritePage {
    favouritePage {
      data {
        attributes {
          title
          yourFavouriteTitle
          podcastTitle
          noPodcastsFoundMsg
          resourcesTitle
          noResourcesFoundMsg
          removeFavourtieBtn
          addFavourite
          courseTitle
          noCoursesFoundMsg
          createdAt
          updatedAt
        }
      }
    }
  }
`;
